module.exports = __webpack_public_path__ + "static/media/logo.f196a29a.png";